"use client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icons } from "@/components/Icons";
import { Button, Card, StickyBar, TopBar } from "@/components/ui";

export function NewPaymentScreen() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div style={{ paddingBottom: 140 }}>
      <TopBar title={t("v2.payments.add_title")} onBack={() => navigate(-1)} />

      <div style={{ padding: "16px 16px", display: "flex", flexDirection: "column", gap: 14 }}>
        <Card padding={16}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: "var(--primary-50)",
                display: "grid",
                placeItems: "center",
                color: "var(--primary-700)",
              }}
            >
              <Icons.card size={20} />
            </div>
            <div>
              <div className="display" style={{ fontSize: 15, fontWeight: 700 }}>{t("v2.payments.saved_at_checkout_title")}</div>
              <div style={{ fontSize: 12, color: "var(--ink-3)", marginTop: 2 }}>
                {t("v2.payments.saved_at_checkout_desc")}
              </div>
            </div>
          </div>
          <div style={{ fontSize: 13, color: "var(--ink-2)", lineHeight: 1.5 }}>
            {t("v2.payments.save_card_hint")}
          </div>
        </Card>

        <Card padding={14} style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "var(--surface-2)",
              display: "grid",
              placeItems: "center",
              color: "var(--ink-1)",
            }}
          >
            <Icons.shield size={18} />
          </div>
          <div style={{ flex: 1, fontSize: 13, color: "var(--ink-2)" }}>
            {t("v2.payments.tokenized_hint")}
          </div>
        </Card>
      </div>

      <StickyBar
        style={{ bottom: 0, paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
      >
        <Button full size="lg" onClick={() => navigate("/cart")}>
          {t("v2.payments.go_to_checkout")}
        </Button>
      </StickyBar>
    </div>
  );
}
